import React from 'react';

// Bottom-of-list marker for useLazyList. It is both the progress readout
// ("Showing 25 of 812") and the IntersectionObserver target that pulls in the
// next chunk, plus a manual button for anyone who never scrolls it into view
// (keyboard users, and browsers where the observer never fires).
const LazyListFooter = ({
    sentinelRef,
    hasMore,
    onLoadMore,
    visibleCount,
    total,
    noun = 'rows',
    className = '',
}) => {
    if (!hasMore) return null;
    return (
        <div
            ref={sentinelRef}
            className={`flex items-center justify-center gap-3 px-4 sm:px-6 py-4 text-xs text-[#6B7280] ${className}`}
        >
            <span>
                Showing {visibleCount} of {total} {noun}
            </span>
            <button
                type="button"
                onClick={onLoadMore}
                className="rounded-xl border border-[#E5E7EB] bg-white px-3 py-1.5 text-xs font-semibold text-[#5B3FE0] transition-colors hover:bg-[#EFEAFE]"
            >
                Load more
            </button>
        </div>
    );
};

export default LazyListFooter;
